import { FC } from 'react';
import Rating from '@mui/material/Rating';
import { BaseInputLabel } from '@ui/index';

type RatingField = {
  label: string;
  mode: 'view' | 'edit';
  form: {
    values: object;
    setFieldValue: (name: string, value: number | null) => void;
  };
  field: {
    name: string;
    value: number;
  };
};

export const RatingField: FC<RatingField> = (props) => {
  const onChange = (_: React.SyntheticEvent, value: number | null) =>
    props.form.setFieldValue(props.field.name, value);

  return (
    <>
      <BaseInputLabel style={{ color: '#65657B', marginBottom: 10 }}>
        {props.label}
      </BaseInputLabel>
      <Rating
        readOnly={props.mode === 'view'}
        value={props.field.value ?? null}
        onChange={onChange}
      />
    </>
  );
};
